import { io } from 'socket.io-client';

const socket = io(process.env.REACT_APP_SOCKET_ENDPOINT, {
  path: process.env.REACT_APP_SOCKET_PATH,
  // query: { token: localStorage.getItem("token") },
  extraHeaders: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

export default socket;
